import { createSelector } from 'reselect';
import { getLanguage } from '@gameday/utils/selectors/getLanguage';
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import { createGamePkSelector } from '@gameday/utils/selectors/getGameStaticData';

const getAppPath = (state) => state?.config?.appPath ?? '';
const getLocalTimezone = (state) => state.config?.localTimezone;
const getGameContext = (state) => state?.config?.context?.gameContext;
const getGameData = (state) => state?.gumbo?.gameData;
const getGamePk = (state) => getGameData(state)?.game.pk;
const getDateTime = (state) => getGameData(state)?.datetime?.dateTime;
const et = 'America/New_York';
const getPromoInterstitial = (state) => state?.productConfig?.promoInterstitial;
const getGameState = (state) => {
    const status = state?.gumbo?.gameData?.status || {};
    const { abstractGameState = '' } = status;
    return abstractGameState;
};

export const getInterstitialMediaState = createGamePkSelector(
    [getLanguage, getLocalTimezone, getGameContext, getGamePk, getDateTime],
    (language, localTimezone, gameContext, gamePk, dateTime) => {
        let formattedDate;

        if (dateTime) {
            formattedDate = format(utcToZonedTime(dateTime, et), 'yyyyMMdd');
        }

        return {
            language,
            gamePk,
            date: formattedDate,
            tz: localTimezone,
            gameContext
        };
    }
);

export const getPromoInterstitialState = createSelector(
    [getPromoInterstitial, getGamePk, getGameState, getAppPath, getLanguage],
    (promoInterstitial, gamePk, gameState, appPath, language) => {
        const matchedPromo = promoInterstitial?.filter((promo) => promo.gamePk === gamePk && promo.state === gameState.toLowerCase());
        return {
            appPath,
            language,
            promoInterstitial: matchedPromo
        };
    }
);
